import React from "react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import { HERO_IMAGES } from "../data/images";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  { q: "What are your trading hours?",
    a: "We trade Monday to Friday from 5:00 PM to 11:00 PM, and Saturday & Sunday from 5:00 PM until late. Times can vary on event nights — follow @tasteofegg_australia on Instagram for live updates." },
  { q: "Where is the food truck located?",
    a: "We're parked at Khau Gali, Clayton — 25 Meriton Place, Clayton South, VIC 3169. One spot, every day. Call 0434 508 712 if you need help finding us." },
  { q: "How spicy is the food?",
    a: "Each dish has a spice indicator — Red is bold, Green is balanced. We can mild it down or crank it up on request, just ask the team at the window." },
  { q: "Do you have vegetarian options?",
    a: "Our entire menu is egg-based — vegetarian and packed with protein. We don't serve any meat. Vegan options are not available as eggs are the star." },
  { q: "Do you do catering or party orders?",
    a: "Yes! We cater parties, work events, weddings & birthdays. Call 0434 508 712 or email info@tasteofegg.com.au with date, headcount and rough menu and we'll send a quote." },
  { q: "Do you deliver?",
    a: "We are primarily a food truck experience — best enjoyed sizzling-fresh at our window in Khau Gali, Clayton. For events, catering delivery is included." },
  { q: "What payment methods do you accept?",
    a: "We accept card (tap & PIN), Apple Pay, Google Pay and cash. There's no surcharge on tap-card transactions." },
  { q: "Do you serve meat or chicken dishes?",
    a: "No — we are 100% egg-focused. That's our entire personality. We do it well." },
  { q: "Can I order ahead and skip the queue?",
    a: "Absolutely. Call ahead on 0434 508 712 with your order and pickup time. Saves you 10–15 minutes on busy nights." },
  { q: "Are your eggs free-range?",
    a: "Yes. We source quality, fresh free-range eggs from local Victorian suppliers." },
];

export default function FAQ() {
  return (
    <div data-testid="page-faq">
      <PageHeader
        eyebrow="Frequently asked"
        title="Everything"
        accent="you wanted to ask."
        subtitle="Quick answers about hours, locations, spice levels, catering and payments."
        image={HERO_IMAGES[0]}
      />
      <section className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="card-dark px-5"
              >
                <AccordionTrigger
                  data-testid={`faq-q-${i}`}
                  className="text-left text-lg font-extrabold hover:text-yellow-brand py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
    </div>
  );
}
